import React from 'react';

interface PageHeaderProps {
  image?: React.ReactNode;
  headline: string;
  subheadline: string;
  imageClassName?: string;
  aboveHeadline?: string;
}

export function PageHeader({ 
  image, 
  headline, 
  subheadline,
  imageClassName = "w-[80px] h-[80px] sm:w-[120px] sm:h-[120px] mx-auto mb-3 sm:mb-8",
  aboveHeadline
}: PageHeaderProps) {
  return (
    <div className="text-center mb-8">
      {image && (
        <div className={imageClassName}>
          {image}
        </div>
      )}
      {aboveHeadline && (
        <p className="text-lg sm:text-xl font-medium text-[#361E06] mb-2 opacity-80">
          {aboveHeadline}
        </p>
      )}
      <h1 className="text-2xl sm:text-6xl mb-2 font-newsreader font-extrabold text-[#361E06]">
        {headline}
      </h1>
      <p className="sm:mt-2 sm:text-4xl text-[#361E06] font-newsreader font-light">
        {subheadline}
      </p>
    </div>
  );
}

export default PageHeader;
